import AppContainer from "./containers/AppContainer";
import "./index.css";

export function App() {
  return <AppContainer />;
}

export default App;
